import { render, staticRenderFns } from "./PoliceAlacakForm.vue?vue&type=template&id=06dc26e5"
import script from "./PoliceAlacakForm.vue?vue&type=script&lang=ts"
export * from "./PoliceAlacakForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports